import { post } from './fetch'
import { createRequestCache, requestCacheKey } from './requestCache'

let browserCache: ReturnType<typeof createRequestCache<unknown>> | undefined
const cache = () => {
  if (typeof window === 'undefined') return undefined
  return browserCache || (browserCache = createRequestCache<unknown>())
}

export const searchPreviewRequest = (shop: { shop: number; lang?: string }, suche: string) => ({
  ...shop, suche, size: 4, page: 1, fuzzy: false, preview: true,
})

export const searchListingRequest = (shop: { shop: number; lang?: string }, suche: string) => ({
  ...shop, suche, size: 24, page: 1, fuzzy: false,
  options: [] as (number | number[])[], brands: [] as number[], includeMetadata: false,
})

export const peekSearchRequest = <T>(url: string, body: unknown, valid: (value: unknown) => value is T): T | undefined => {
  const value = cache()?.peek(requestCacheKey(url, body))
  return value !== undefined && valid(value) ? value : undefined
}

export const joinSearchRequest = (url: string, body: unknown) =>
  cache()?.join(requestCacheKey(url, body))

export const requestSearch = <T>(url: string, body: unknown, valid: (value: unknown) => value is T) => {
  const browser = cache()
  if (!browser) throw new Error('Search request cache is browser-only')
  const subscription = browser.acquire(requestCacheKey(url, body), async signal => {
    const value = await post({ url, body, signal })
    if (signal.aborted || !valid(value)) throw new Error('Die Suche konnte nicht geladen werden.')
    return value
  })
  return { promise: subscription.promise as Promise<T>, release: subscription.release }
}
